import { Circle, type GetProps, styled, Theme } from "tamagui";
type RadioIndicatorProps = {
  checked?: boolean;
  disabled?: boolean;
} & Pick<GetProps<typeof Circle>, "focusable" | "tabIndex" | "aria-hidden">;
import { sizeTokens } from "../themes/token-size";
import { borderSizeTokens } from "../themes/token-space";
const size = sizeTokens.si3;
const borderWidth = borderSizeTokens.border2;
const innerSelectedSize = sizeTokens.si1;
const innerUnselectedSize = size - borderWidth * 2;
const Outer = styled(Circle, {
  name: "RadioIndicator",
  width: size,
  height: size,
  justifyContent: "center",
  alignItems: "center",
  focusable: true,
  focusVisibleStyle: {
    outlineWidth: borderSizeTokens.border3,
    outlineColor: "$borderIntense",
    outlineStyle: "solid",
    outlineOffset: 1
  },
  variants: {
    checked: {
      true: {
        backgroundColor: "$surfaceStrong"
      },
      false: {
        backgroundColor: "$borderStrong"
      }
    },
    disabled: {
      true: {
        backgroundColor: "$borderDefaultHover"
      }
    }
  } as const,
  defaultVariants: {
    checked: false,
    disabled: false
  }
});
const Inner = styled(Circle, {
  name: "SelectionRadioInner",
  variants: {
    checked: {
      true: {
        width: innerSelectedSize,
        height: innerSelectedSize
      },
      false: {
        width: innerUnselectedSize,
        height: innerUnselectedSize
      }
    },
    disabled: {
      true: {
        backgroundColor: "$surface0"
      },
      false: {
        backgroundColor: "$surface2"
      }
    }
  } as const,
  defaultVariants: {
    checked: false,
    disabled: false
  }
});
export const RadioIndicator = ({
  checked = false,
  disabled = false,
  focusable = false,
  tabIndex,
  ...props
}: RadioIndicatorProps) => <Theme name="v2" data-sentry-element="Theme" data-sentry-component="RadioIndicator" data-sentry-source-file="RadioIndicator.tsx">
    <Outer checked={checked} disabled={disabled} focusable={focusable} tabIndex={tabIndex} transition="quick" animateOnly={["backgroundColor"]} {...props} data-sentry-element="Outer" data-sentry-source-file="RadioIndicator.tsx">
      <Inner checked={checked} disabled={disabled} transition="quick" animateOnly={["width", "height"]} data-sentry-element="Inner" data-sentry-source-file="RadioIndicator.tsx" />
    </Outer>
  </Theme>;
export type { RadioIndicatorProps };